import { Box, Button, FormControl, Input } from '@deckee/deck-hand';
import React, { FC } from 'react';
import styled from 'styled-components';

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

interface SignInFormProps {
  updateField: (email: string) => void;
  requestEmailAuthentication: () => Promise<void>;
  focusInputRef?: unknown;
  submitting?: boolean;
  email?: string;
  className?: string;
}

const SignInForm: FC<SignInFormProps> = (props) => {
  const {
    updateField,
    requestEmailAuthentication,
    focusInputRef,
    submitting,
    email,
    className,
  } = props;

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    await requestEmailAuthentication();
  };

  return (
    <StyledForm
      className={className}
      onSubmit={async (event) => handleSubmit(event)}
    >
      <Box mt="2">
        <FormControl label="Your email" name="email" required>
          <Input
            inputRef={focusInputRef}
            autoFocus
            type="email"
            value={email}
            placeholder="Email address"
            onChange={(e: { target: { value: string } }) =>
              updateField(e.target.value)
            }
          />
        </FormControl>

        <Button.Group mb={3} wide width="100%">
          <Button type="submit" disabled={submitting || !email}>
            {submitting ? 'Submitting...' : 'Continue'}
          </Button>
        </Button.Group>
        <Box mb={1} fontSize={0}>
          {`By continuing, you agree to the Deckee `}
          <Button link href="https://deckee.com/terms-of-use">
            Terms of Use
          </Button>
          {' and '}
          <Button link href="https://deckee.com/privacy-policy">
            Privacy Policy
          </Button>
          .
        </Box>
      </Box>
    </StyledForm>
  );
};

SignInForm.defaultProps = {
  email: '',
  focusInputRef: undefined,
  submitting: false,
  className: undefined,
};

export default SignInForm;
